import { render, staticRenderFns } from "./BotaoVoltar.vue?vue&type=template&id=30492752&scoped=true&"
import script from "./BotaoVoltar.vue?vue&type=script&lang=js&"
export * from "./BotaoVoltar.vue?vue&type=script&lang=js&"
import style0 from "./BotaoVoltar.vue?vue&type=style&index=0&id=30492752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30492752",
  null
  
)

export default component.exports